/**
 * Expand-to-fullscreen gating for record comments
 * (operator-task-fe-comment-fullscreen-expand, Margot).
 *
 * The expand affordance only earns its place on comments that are long enough
 * that the limited inline comment scroll window becomes a real constraint
 * (Margot: "we often have very long comments and a limited scroll window").
 * Short one-liners read fine inline, so they get no expand control — keeping
 * quiet comments uncluttered (ui-design-principle-inline-hover-actions).
 */

// A comment qualifies when it is either substantial in length or spans several
// lines. The thresholds are deliberately generous so the control appears for
// genuinely-long prose, not every two-sentence note.
export const COMMENT_EXPAND_MIN_CHARS = 200;
export const COMMENT_EXPAND_MIN_LINES = 4;

export const isExpandableComment = (body: string | null | undefined): boolean => {
    if (!body) {
        return false;
    }
    if (body.length > COMMENT_EXPAND_MIN_CHARS) {
        return true;
    }
    return body.split("\n").length >= COMMENT_EXPAND_MIN_LINES;
};
